/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import UpdateIcon from '@material-ui/icons/Update';
import { useSelector } from 'react-redux';
import { RootState } from '../../storage/rootReducer';

import {
  Content,
  TabelaContainer,
  Status,
} from './styles';
import Tabela from '../../components/Tabelas/Tabela';
import HeaderProposta from '../../components/HeaderProposta';
import cores from '../../styles/cores';
import PropostasService from '../../services/PropostasService';
import { isSignedIn } from '../../services/auth';

const PropostasRegional: React.FC = () => {
  const [detalhes, setDetalhes] = useState(false);
  const [userData, setUserData] = useState({});
  const [pageMenu, setPageMenu] = useState('principal');
  const [listarPropostas, setListarPropostas] = useState<any[]>();
  const [listPhysical, setListPhysical] = useState([]);
  const [listLegal, setListLegal] = useState([]);
  const history = useHistory();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const { state } = useLocation();
  const use = useSelector((state: RootState) => state.userReducer);

  const list = useCallback(async () => {
    setIsDataLoading(true);
    // const physical = await PropostasService.getProposalsPhysical();
    const physical = await PropostasService.getProposalsPhysicalRegional();
    console.log('physical>>', physical.proposal);

    let physicalFormatted = physical.proposal.map((item: any) => {
      let documento;
      let nome;
      let physical_formatted
      console.log('item.proposals_participants ', item);

      if (item.proposals_participants.length > 0) {
        documento = item.proposals_participants[0].cpf;
        nome = item.proposals_participants[0].nome;
      }

       physical_formatted = {
        id: item.id,
        nome: nome,
        documento: documento,
        status:  item.quadra_lote === '0/0' ? 'Ficha Cadastral' :  item.status,
        atualizacao: item.updated_at,
        estado_civil: item.estado_civil,
        sexo: item.sexo,
        data_nascimento: item.data_nascimento,
        num_filhos: item.num_filhos,
        renda_familiar: item.renda_familiar,
        num_entradas: item.num_entradas,
        valor_entrada: item.valor_entrada,
        num_parcelas: item.num_parcelas,
        valor_parcelas: item.valor_parcelas,
        valor_total: item.valor_total,
        objetivo: item.objetivo,
        telefone: item.telefone,
        email: item.email,
        criacao: item.created_at,
        documentosFisica: item.documentos,
        participantes: item.proposals_participants,
        empreendimento: item.empreendimento,
        clt: item.clt,
        quadra_lote: item.quadra_lote === '0/0' ? 'Não se aplica' : item.quadra_lote,
        tipo: 'physical',
      };

      if(item.data_vencimento_parcela === null || item.data_vencimento_parcela === undefined || item.data_vencimento_sinal === null || item.escolaridade === null || item.escolaridade === '' || item.clt === '' || item.clt === undefined || item.clt === null || item.clt === 'null' || item.clt === 'undefined' || item.clt === 'null' || item.clt === 'undefined') {
        physical_formatted = {

        }
      }

      return physical_formatted;
    });
    setListarPropostas(physicalFormatted);
    setIsDataLoading(false);
  }, []);

  useEffect(() => {
    if (!isSignedIn()) {
      history.push('/');
    }
    list();
    console.log('propostas ', listarPropostas);
  }, []);

  const columns = [
    {
      title: 'Última atualização',
      field: 'atualizacao',
      type: 'date',
    },
    {
      title: 'Participante Principal',
      field: 'nome',
    },
    {
      title: 'Documento (CPF/CNPJ)',
      field: 'documento',
    },
    {
      title: 'Empreedimento',
      field: 'empreendimento',
    },
    {
      title: 'Quadra / Lote',
      field: 'quadra_lote',
      },
    {
      title: 'Status',
      field: 'status',
      render: (rowData: any) => {
        if (rowData.status === 'Em Análise') {
          return (
            <Status>
              {/* <Ball color="yellow" /> */}
              <UpdateIcon
                style={{ fill: 'orange', marginRight: 5, fontSize: 26 }}
              />
              Em análise
            </Status>
          );
        }
        if (rowData.status === 'Aprovado') {
          return (
            <Status>
              {/* <Ball color="green" /> */}
              <DoneIcon
                style={{ fill: 'green', marginRight: 5, fontSize: 26 }}
              />
              Aprovado
            </Status>
          );
        }
        if (rowData.status === 'Anexar Documentos') {
          return (
            <Status>
              {/* <Ball color="blue" /> */}
              <AttachFileIcon
                style={{ fill: cores.blue, marginRight: 5, fontSize: 26 }}
              />
              Anexar documentos
            </Status>
          );
        }
        if (rowData.status === 'Reprovado') {
          return (
            <Status>
              {/* <Ball color="red" /> */}
              <ClearIcon style={{ fill: 'red', marginRight: 5, fontSize: 26 }} />
              Reprovado
            </Status>
          );
          }
          return (
            <Status>
              {rowData.status || 'Status não definido'}
            </Status>
          );
      },
    },
  ];

  const [isModalOpen, setModalOpen] = useState(false);

  function rowSelected(e: any, rowData: any) {
    console.log('isso vai para o editar ', rowData);
    history.push({
      pathname: '/painel/proposta/editar',
      state: { rowData },
    });
  }
  function adicionarCorretor() {
    setPageMenu('adicionar');
  }

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setModalOpen(false);
    setOpen(true);
  };

  return (
    <>
      <HeaderProposta />
      <Content>

        <TabelaContainer>
          <Tabela
            title="Propostas"
            haveActions="edit"
            columns={columns}
            isLoading={isDataLoading}
            data={listarPropostas}
            onRowClick={(e: any, rowData: any): any => {
              if (rowData.status !== 'Ficha Cadastral') {
                setListarPropostas(rowData);
                rowSelected(e, rowData);
              } else {
                console.log('Ficha Cadastral');
              }
            }}
            excluirClick={() => {
              console.log('');
            }}
            editarClick={(e: any, rowData: any): any => {
              setListarPropostas(rowData);
              rowSelected(e, rowData);
            }}
            pagination
            paginationPageSize={10}
          />
        </TabelaContainer>
      </Content>
    </>
  );
};

export default PropostasRegional;
